const Style = {
  article: 'py-12 md:py-16',
}

export default Style
